import React, { useState } from 'react';
import { QRCodeCanvas } from "qrcode.react";
import { ReactComponent as COPY } from '../../../../assets/IconsColurs/IconsGeneral/copy.svg';
import { ReactComponent as Alert } from '../../../../assets/IconsColurs/IconsGeneral/alert.svg';
import { copyToClipboard } from '../../../../utils/Utils'
import USDT from '../../../../assets/currency/usdt.png'
import USDC from '../../../../assets/currency/usdc.png'
import LoadingSpinner from '../../../spinners/LoadingSpinner';
import CopyNotification from '../../../banners/CopyNotification'

const MultiQr = ({
    ID_USDT = "TwZ33pqZxFG",
    ID_USDC = "TwZ2441x3490pq4555",
    QR_USDT = ID_USDT,
    QR_USCD = ID_USDC,
    qrValue = "https://example.com",
    centerImage,
    loadingAddressQr,
    addressQrUSDC,
    addressQrUSDT
}) => {

    const [selected, setSelected] = useState('USDT');
    const handleSelect = (currency) => {
        setSelected(currency);
    };

    const [show, setShow] = useState(false)

    const Copy = () => {
        copyToClipboard((selected === 'USDT' ? addressQrUSDT : addressQrUSDC), setShow);
    };

    return (
        <>
            <CopyNotification show={show} />
            <p className='w-full flex mb-4 text-[14px] font-normal text-[#B7B7B9] tracking-[-0.14px] text-start leading-5'>
                Elige entre USDT o USDC y comparte tu código QR o Wallet Address para recibir el pago.
            </p>
            <div className='w-full h-[5vh] flex flex-row justify-center items-center gap-4 mt-6'>
                <div
                    className={`flex flex-row p-1 rounded-full ${selected === 'USDT' ? 'bg-white text-black' : 'bg-[#5E5E6329] text-white'
                        } justify-center items-center gap-2 px-5`}
                    onClick={() => handleSelect('USDT')}
                >
                    <img src={USDT} className='cover flex' width={20} alt='logo usdt' />
                    <p className={`text-sm ${selected === 'USDT' ? 'text-black' : 'text-white'}`}>USDT</p>
                </div>
                <div
                    className={`flex flex-row p-1 rounded-full ${selected === 'USDC' ? 'bg-white text-black' : 'bg-[#5E5E6329] text-white'
                        } justify-center items-center gap-2 px-5`}
                    onClick={() => handleSelect('USDC')}
                >
                    <img src={USDC} className='cover flex' width={20} alt='logo usdc' />
                    <p className={`text-sm ${selected === 'USDC' ? 'text-black' : 'text-white'}`}>USDC</p>
                </div>
            </div>
            {loadingAddressQr && <LoadingSpinner />}
            {!loadingAddressQr && <div className='w-full h-full py-5 flex flex-col justify-center items-center ' >

                <div className='relative w-[200px] h-[200px] flex justify-center items-center'>
                    {/* Esquinas en forma de L */}
                    <div className="absolute top-0 left-0 w-6 h-6 border-t-4 border-l-4  border-white"></div>
                    <div className="absolute top-0 right-0 w-6 h-6 border-t-4 border-r-4   border-white"></div>
                    <div className="absolute bottom-0 left-0 w-6 h-6 border-b-4 border-l-4  border-white"></div>
                    <div className="absolute bottom-0 right-0 w-6 h-6 border-b-4 border-r-4  border-white"></div>

                    {/* QR Code */}
                    <div style={{ position: "relative", display: "inline-block" }}>
                        <QRCodeCanvas
                            value={selected === 'USDT' ? addressQrUSDT : addressQrUSDC}
                            size={180} // Tamaño del QR
                            bgColor="transparent" // Color de fondo
                            fgColor="#ffffff" // Color del QR
                            level="H" // Nivel de corrección de errores
                        />
                        <img
                            src={selected === 'USDT' ? USDT : USDC}
                            alt="Center Logo"
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: "70px", // Tamaño de la imagen
                                height: "70px",
                                borderRadius: "50%",
                                background: "transparent",
                                padding: "5px",
                            }}
                        />
                    </div>
                </div>
                <div
                    className='w-auto h-auto flex flex-row gap-2 items-center justify-center cursor-pointer m-3'
                    onClick={Copy} // Convierte ID_user a string si es numérico
                >
                    <p className='flex text-base font-normal text-[#B7B7B9] tracking-[-0.14px] leading-5'>
                        Wallet Address:
                    </p>
                    <p className='flex text-base font-normal text-[#ffffff] tracking-[-0.14px] leading-5'>
                        {selected === 'USDT' ? addressQrUSDT : addressQrUSDC}
                    </p>
                    <COPY />
                </div>


                <div className='w-full  h-auto bg-[#F2D0A9] rounded-[12px] flex flex-row gap-5 justify-center items-center p-3 mt-4' >
                    <Alert className='w-7 h-7' />
                    <p className='text-[14px] text-[#26262D] text-start ' >Solo puedes transferir tokens basados en la red de TRON (TRC20) a esta billetera. Otros tokens se perderán durante la transferencia.</p>
                </div>

            </div>}
        </>
    );
};

export default MultiQr;
